import { observer } from 'mobx-react-lite';
import {
  CircledIcon,
  PageContainer,
  PageFooter,
  StepProps,
} from '../../../shared_components';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import {
  Stack,
  Title,
  Text,
  Flex,
  TextInput,
  Button,
  Image,
  Space,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import classes from '../../../app.module.css';

export const StepFinalizeRegistration = observer(({ forward }: StepProps) => {
  const { t } = useTranslation(['registration', 'common']);
  const form = useForm();

  return (
    <PageContainer>
      <form>
        <Flex direction={'column'} justify={'space-between'} h={'100%'}>
          <Stack classNames={{ root: classes.footerPadding }}>
            <CircledIcon icon={<CheckIcon sx={{ fontSize: 48 }} />} />
            <Title style={{ textAlign: 'center' }} order={2}>
              {t('finalize_registration_title')}
            </Title>
            <Text style={{ textAlign: 'center' }}>
              {t('finalize_registration_message')}
            </Text>
            <Space />
            <Stack gap={'var(--mantine-spacing-xl)'}>
              <Flex direction={'row'} justify={'center'}>
                <Button
                  variant={'text'}
                  leftSection={
                    <Image src={'/../../../assets/img/profile_black.svg'} />
                  }
                >
                  {t('upload_picture')}
                </Button>
              </Flex>
              <TextInput
                placeholder={t('name')}
                key={form.key('name')}
                {...form.getInputProps('name')}
              />
            </Stack>
          </Stack>
          <PageFooter
            hideBack
            buttonText={t('lets_go')}
            rightOnClick={forward}
            submitButton
          />
        </Flex>
      </form>
    </PageContainer>
  );
});
